// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerListBlockForm_root__3d1yv","items":"AnswerListBlockForm_items__2X9s7","item":"AnswerListBlockForm_item__HU5ye","addButton":"AnswerListBlockForm_addButton__60uhm"};